import React from 'react';

const BlogIcon = ({ width = 24, height = 24, color = 'white', ...props }) => (
  <svg width={width} height={width} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      d="M24 11.0281C24 8.35745 22.2744 6.09142 19.8711 5.24744V16.8088C22.2744 15.9648 24 13.6988 24 11.0281Z"
      fill={color}
    />
    <path
      d="M11.5224 5.60872H3.25164C0.421991 5.60872 0 7.19263 0 8.13777V13.9185C0 14.8188 0.408984 16.2828 2.89035 16.4215V21.1443C2.89035 22.562 4.21268 23.6734 5.90064 23.6734H7.82706C9.51502 23.6734 10.8374 22.562 10.8374 21.1443V16.4475H11.5209L18.0632 22.0562V0L11.5224 5.60872ZM8.67104 21.1443C8.67104 21.2137 8.39068 21.5056 7.82851 21.5056H5.90209C5.33992 21.5056 5.05955 21.2137 5.05955 21.1443V16.4475H8.67249V21.1443H8.67104ZM15.8969 17.3421L12.323 14.2798H3.25164C2.35708 14.2798 2.19522 14.1121 2.19522 14.1107C2.18799 14.0991 2.16776 14.0399 2.16776 13.9185V8.13777C2.16776 8.01638 2.18799 7.95713 2.19377 7.94701C2.19522 7.94556 2.35708 7.77648 3.25164 7.77648H12.323L15.8969 4.71416V17.3421Z"
      fill={color}
    />
  </svg>
);

export default BlogIcon;
